import { getTranslation } from '../../getTranslation';

export const facetHeaderTemplate = (html, attribute, currency = '') => {
	const title = getTranslation(attribute);

	// TODO: consider changing span to h2 or h3 for better page navigation
	return html` <span>${title} ${currency ?? ''}</span> `;
};

export const facetBodyTemplate = (item, html, facetAttributeName) => {
	const { label, count, isRefined } = item;
	const customClassName = 'ais-FacetCheckbox';

	return html`
		<label class="${customClassName}-label">
			<input
				id="${facetAttributeName}_${label}"
				class="${customClassName}-checkbox"
				type="checkbox"
				value="${label}"
				checked="${isRefined}"
			/>
			<span class="${customClassName}-facetName">${label} (${count})</span>
		</label>
	`;
};
